module.exports = "/images/vendor/flag-icon-css/flags/1x1/aq.svg?65448909a82325121a92bb71012091d7";